export const merchantQueryKeys = {
	all: () => ["merchants"],
	clientMerchantsList: (clientTenant: string, pageSize?: number) => [
		...merchantQueryKeys.all(),
		"client-merchants-list",
		{ clientTenant, pageSize },
	],
	availableMerchantsList: (clientTenant: string, pageSize?: number) => [
		...merchantQueryKeys.all(),
		"available-merchants-list",
		{ clientTenant, pageSize },
	],
};
